import React, { useContext } from 'react';
import ChatAppContext from '../../../Context/Chat';
import { Image, LI, UL } from '../../../AbstractElements';

const PeopleList = () => {
  const { allMemberss } = useContext(ChatAppContext);
  return (
    <div className='people-list'>
      <UL className='list digits custom-scrollbar'>
        {allMemberss.map((member, id) => {
          return (
            <LI key={id} className='clearfix'>
              <div className='d-flex'>
                <Image className='rounded-circle user-image' src={`${require(`../../../assets/images/${member.thumb}`)}`} alt='' />
                <div className='about flex-grow-1'>
                  <div className='name'>{member.name}</div>
                  <div className='status'>
                    <i className={member.reply}></i>
                    {member.time}
                  </div>
                </div>
              </div>
            </LI>
          );
        })}
      </UL>
    </div>
  );
};

export default PeopleList;
